(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"] && !Shopify.designMode) return;
  try {
    
class ComingSoon extends HTMLElement {
  connectedCallback() {
    // password dialog
    this.dialog = this.querySelector('[data-cs-dialog]');
    this.opener = this.querySelector('[data-cs-open]');
    this.opener?.addEventListener('click', () => this.open());
    this.dialog?.querySelectorAll('[data-cs-close]').forEach((el) => el.addEventListener('click', () => this.close()));
    this.onKey = (e) => { if (e.key === 'Escape') this.close(); };
    // a wrong password comes back with an error: reopen the dialog
    if (this.dialog && this.dialog.querySelector('.cs__error')) this.open();

    // countdown
    const cd = this.querySelector('[data-cs-countdown]');
    if (cd) {
      const raw = (cd.dataset.csCountdown || '').trim().replace(' ', 'T');
      const target = new Date(raw).getTime();
      if (!Number.isNaN(target)) {
        const el = { d: cd.querySelector('[data-cs-d]'), h: cd.querySelector('[data-cs-h]'), m: cd.querySelector('[data-cs-m]'), s: cd.querySelector('[data-cs-s]') };
        const pad = (n) => String(n).padStart(2, '0');
        const tick = () => {
          const diff = Math.max(0, target - Date.now());
          const d = Math.floor(diff / 864e5);
          const h = Math.floor((diff % 864e5) / 36e5);
          const m = Math.floor((diff % 36e5) / 6e4);
          const s = Math.floor((diff % 6e4) / 1e3);
          if (el.d) el.d.textContent = pad(d);
          if (el.h) el.h.textContent = pad(h);
          if (el.m) el.m.textContent = pad(m);
          if (el.s) el.s.textContent = pad(s);
          if (diff <= 0) clearInterval(this.timer);
        };
        tick();
        this.timer = setInterval(tick, 1000);
      }
    }
  }
  open() {
    if (!this.dialog) return;
    this.dialog.hidden = false;
    document.addEventListener('keydown', this.onKey);
    this.dialog.querySelector('[data-cs-focus]')?.focus();
  }
  close() {
    if (!this.dialog) return;
    this.dialog.hidden = true;
    document.removeEventListener('keydown', this.onKey);
    this.opener?.focus();
  }
  disconnectedCallback() { clearInterval(this.timer); }
}
if (!customElements.get('coming-soon')) customElements.define('coming-soon', ComingSoon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
class ProductReviews extends HTMLElement {
  connectedCallback() {
    this.perPage = parseInt(this.dataset.perPage || 6, 10);
    this.shown = this.perPage;
    this.filter = 'all';
    this.sort = 'newest';
    this.cardsWrap = this.querySelector('[data-review-cards]');
    this.cards = [...this.querySelectorAll('[data-review]')];
    this.moreBtn = this.querySelector('[data-review-more]');
    this.countEl = this.querySelector('[data-review-count]');
    this.baseCount = this.countEl ? this.countEl.textContent : '';

    this.moreBtn?.addEventListener('click', () => { this.shown += this.perPage; this.render(); });
    this.querySelector('[data-review-sort]')?.addEventListener('change', (e) => { this.sort = e.target.value; this.render(); });
    const filters = this.querySelector('[data-review-filters]');
    this.querySelector('[data-review-filter-toggle]')?.addEventListener('click', (e) => {
      const open = filters.hidden;
      filters.hidden = !open;
      e.currentTarget.setAttribute('aria-expanded', String(open));
    });
    this.querySelectorAll('[data-review-filter]').forEach((chip) => chip.addEventListener('click', () => {
      this.querySelectorAll('[data-review-filter]').forEach((c) => c.classList.toggle('is-active', c === chip));
      this.filter = chip.dataset.reviewFilter;
      this.shown = this.perPage;
      this.render();
    }));

    // Customer videos: tap to play with sound; only one plays at a time
    this.querySelectorAll('[data-video-play]').forEach((btn) => btn.addEventListener('click', () => {
      const fig = btn.closest('.prv__video');
      const video = fig?.querySelector('video');
      if (!video) return;
      this.querySelectorAll('.prv__video video').forEach((v) => { if (v !== video) { v.pause(); v.closest('.prv__video')?.classList.remove('is-playing'); } });
      video.muted = false;
      video.controls = true;
      fig.classList.add('is-playing');
      video.play().catch(() => {});
      video.addEventListener('ended', () => { fig.classList.remove('is-playing'); video.controls = false; }, { once: true });
    }));

    this.render();
  }

  render() {
    let list = this.cards.filter((c) => this.filter === 'all' || c.dataset.rating === this.filter);
    if (this.sort === 'highest') list = [...list].sort((a, b) => b.dataset.rating - a.dataset.rating || a.dataset.order - b.dataset.order);
    else if (this.sort === 'lowest') list = [...list].sort((a, b) => a.dataset.rating - b.dataset.rating || a.dataset.order - b.dataset.order);
    else list = [...list].sort((a, b) => a.dataset.order - b.dataset.order);
    this.cards.forEach((c) => { c.hidden = true; });
    list.forEach((c, i) => { c.hidden = i >= this.shown; this.cardsWrap.appendChild(c); });
    let empty = this.cardsWrap.querySelector('.prv__empty');
    if (!list.length) {
      if (!empty) { empty = document.createElement('p'); empty.className = 'prv__empty'; empty.textContent = 'No reviews with this rating yet.'; this.cardsWrap.appendChild(empty); }
    } else empty?.remove();
    if (this.moreBtn) this.moreBtn.hidden = list.length <= this.shown;
  }
}
if (!customElements.get('product-reviews')) customElements.define('product-reviews', ProductReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology-grid"] && !Shopify.designMode) return;
  try {
    
class TechnologyGrid extends HTMLElement {
  connectedCallback() {
    this.cards = [...this.querySelectorAll('.tcard')];
    const countAll = this.querySelector('[data-count-all]');
    if (countAll) countAll.textContent = this.cards.length;
    this.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-filter]');
      if (chip) this.filter(chip.dataset.filter);
    });
  }
  filter(key) {
    this.querySelectorAll('[data-filter]').forEach((b) => {
      const on = b.dataset.filter === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
    this.cards.forEach((c) => { c.hidden = !(key === 'all' || c.dataset.cat === key); });
    this.querySelectorAll('[data-group]').forEach((g) => {
      const any = [...g.querySelectorAll('.tcard')].some((c) => !c.hidden);
      g.hidden = !any;
      const heading = this.querySelector(`[data-group-heading="${g.dataset.group}"]`);
      if (heading) heading.hidden = !any;
    });
  }
}
if (!customElements.get('technology-grid')) customElements.define('technology-grid', TechnologyGrid);

  } catch(e) { console.error(e); }
})();
})();
